var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-message-page',{attrs:{"msg":this.msg,"msg-type":"success","icon":"check","buttons":_vm.noButtons ? [] : [_vm.next]}})}
var staticRenderFns = []

export { render, staticRenderFns }